<template>
    <div class="component-interaction pl-2 pr-2">
      <ComponentTopHeader @onBack="goBack" ></ComponentTopHeader>
      <div class="main-container">
        <iframe   
            src="http://111.10.70.56:3398/website"   
            width="100%"   
            height="100%"  
        ></iframe> 
      </div>
    </div>
  </template>
  <script>
  import ComponentTopHeader from "../components/datav/TopHeader.vue";
  
  export default {

    components: {ComponentTopHeader},
    data() {
      return {
        
      };
    },
    methods: {
      goBack() {
        this.$store.dispatch("app/changeMapCount", 0);
        this.$store.dispatch("app/initAddress");
        // this.$store.dispatch("app/getGlobalData", { key: "" });
  
        this.$router.go(-1);
      },
    },
    mounted() {
    },
  };
  </script>
  <style lang="less" scoped>
  .component-interaction {
    height: 100%;
    //   background: #eef0f3;
    background: @background-color;
    background-image: url("../components/datav/img/bg.png");
    background-size: 100% 100%;
    // background: linear-gradient(95deg, #abd1e7, #abd1e7);
    // ::v-deep {
    //   .el-card {
    //     color: #abd1e7 !important;
  
    //     border: 1px solid #4bace0;
    //   }
    //   .el-card__header {
    //     border-bottom: 1px solid #4bace0;
    //   }
    // }
    .main-container {
      display: flex;
      height: calc(100% - 170px);
      .left-container,
      .right-container {
        flex: 1;
        background: rgba(0, 0, 0, 0);
      }
      .center-container {
        width: 50%;
        background: rgba(0, 0, 0, 0);
      }
    }
  }
  </style>
  